import { render, staticRenderFns } from "./ElementGroupEdition.vue?vue&type=template&id=4d619854&scoped=true"
import script from "./ElementGroupEdition.vue?vue&type=script&lang=js"
export * from "./ElementGroupEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d619854",
  null
  
)

export default component.exports